import { useGlobalForegroundLoading } from "@/hooks/useGlobalForegroundLoading";

/** Root-level query + navigation tracker for the single global loading bar. */
export function GlobalForegroundLoadingBridge() {
  useGlobalForegroundLoading();
  return null;
}
